import { createRouter, createWebHistory } from 'vue-router'

import { apiToken } from '@/service/http.service'
import HomeView from '@/views/HomeView.vue'

export const Route = {
  Home: 'home'
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: Route.Home,
      component: HomeView
    }
  ]
})

router.beforeEach(to => {
  const token = to.query.api_token
  if (typeof token === 'string') apiToken.value = token
})

export default router
